import { EndpointResponse } from 'types/api/end-point'
import {
  TeamExternalIntegration,
  ResponseBodyEvaluation
} from 'types/api/services/golden-signal'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const dataDogStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Datadog',
  type: IntegrationType.Datadog,
  authUrl: `${ENDPOINT_URLS.datadog}v2/current_user/application_keys`,
  isPrivateNetworkIntegration: false,
  headers: [
    { key: 'DD-API-KEY', value: '', label: 'API Key' },
    {
      key: 'DD-APPLICATION-KEY',
      value: '',
      label: 'Application Key'
    }
  ],
  url: ENDPOINT_URLS.datadog,
  sortIndex: 0
}

export const datadogMonitorRegex = new RegExp(
  '^https:\\/\\/(app|api).datadoghq.com\\/(monitors|api/v1/monitor)\\/(.+\\d)'
)

export const datadogResponseBodyEvaluationConfiguration = {
  op: 'AND',
  predicates: [
    {
      jpQuery: '.overall_state',
      type: 'String',
      comparator: 'EQU',
      rValue: 'OK'
    }
  ]
} as ResponseBodyEvaluation

export function convertToDatadogApiUrl(url: string): string {
  if (datadogMonitorRegex.test(url)) {
    const isAPIUrl = datadogMonitorRegex.exec(url)?.[2] === 'api/v1/monitor'
    const monitorId = datadogMonitorRegex.exec(url)?.[3]

    if (isAPIUrl) {
      return url
    }

    if (monitorId) {
      return `https://api.datadoghq.com/api/v1/monitor/${monitorId}`
    }
  }

  return null
}

export function getDatadogMonitorName(
  testEndpointResponse: EndpointResponse
): string {
  return JSON.parse(testEndpointResponse?.responseBody)?.name
}
